import React, {useState} from 'react'
import {TopMenuLinkSeparator} from "./TopMenuLinkSeparator";
import {FriendSpaceItem} from "./FriendSpace/FriendSpaceItem";
import AbbiePic from '../../img/Abbie.jpg';
import AnurupPic from './../../img/Anurup2.jpg';
import DickPic from './../../img/Dick.jpg'
import KylePic from './../../img/Kyle.jpg'
import TowniePic from './../../img/Townie.jpg'
import {FriendsCommentsItem} from "./FriendsComments/FriendsCommentsItem";
import {LatestBlogPostItem} from "./LatestBlogPosts/LatestBlogPostItem";
import {websiteUrl} from "../../service/_BackendUrls";


export const LatestBlogPosts = (props) => {

    const [viewAllBlogEntriesClicked, setViewAllBlogEntriesClicked] = useState(false);

    const ViewAllBlogEntriesButton = () => {
        if (viewAllBlogEntriesClicked === false) {
            return <div>
                [
                <button
                    style={{color: 'blue', background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}
                    onClick={() => setViewAllBlogEntriesClicked(true)}
                >View All Blog Entries
                </button>
                ]
            </div>
        } else if (viewAllBlogEntriesClicked === true) {
            return <button
                style={{color: 'black', background: 'none', border: 'none', padding: 0}}
            >
                Displaying 6 of 6 Blog Entries [
                <button
                    style={{color: 'blue', background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}
                    onClick={() => setViewAllBlogEntriesClicked(false)}
                >Show Less
                </button>
                ]
            </button>

        }
    }


    let ContainerStyle = {
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'left',
        marginTop: '2.5%',
        marginBottom: '5%'
    }

    if(props.showNotFriendsExtendedNetworkMessage === true || props.showBlockedExtendedNetworkMessage === true){
        ContainerStyle = {display: 'none'}
    }

    return <div style={ContainerStyle}>
        <div style={{textAlign: 'left', paddingLeft: '5%', marginTop: '1%', fontWeight: 'bold'}}>Matt's Latest Blog
            Posts{' '}
        </div>
        <div style={{marginLeft: '2.5%', marginRight: '2.5%'}}>
            {/*<div style={{*/}
            {/*    width: '100%',*/}
            {/*    background: 'none',*/}
            {/*    display: 'flex',*/}
            {/*    marginLeft: '2.5%',*/}
            {/*    marginTop: '2.5%',*/}
            {/*}}>*/}
            {/*    <div style={{*/}
            {/*        color: 'rgb(48,93,150)',*/}
            {/*    }}>Original art now for sale on Etsy!</div>*/}
            {/*    <div style={{paddingLeft: '1%', flexDirection: 'row', display: 'flex', textAlign: 'left'}}>*/}
            {/*        <div>(</div>*/}
            {/*        <a*/}
            {/*            href="https://www.etsy.com/shop/mjfre/?etsrc=sdt&section_id=54600971"*/}
            {/*            target="_blank"*/}
            {/*            rel="noopener noreferrer"*/}
            {/*        >*/}
            {/*            view more*/}
            {/*        </a>*/}
            {/*        <div>)</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <LatestBlogPostItem title={'My Watercolor Guide to San Diego'} viewMoreLinkPathFromHome={'/mini_painting'}/>
            <LatestBlogPostItem title={'Postcards now for sale!!!'} viewMoreLinkPathFromHome={'/for_sale'}/>
            <LatestBlogPostItem title={'I sat outside and made a painting'} viewMoreLinkPathFromHome={'/painting'}/>
            <LatestBlogPostItem title={'I just released an app on the App Store!'}
                                viewMoreLinkPathFromHome={'/programming'}/>
            <LatestBlogPostItem title={'Learn to cook the best things I know'} viewMoreLinkPathFromHome={'/recipes'}/>
            <LatestBlogPostItem title={'A look back at some of my best photographs'}
                                viewMoreLinkPathFromHome={'/photography'}/>
        </div>
        <div style={{paddingLeft: '5%', marginTop: '2.5%'}}>
            <ViewAllBlogEntriesButton/>
        </div>
        {/*friend space item container*/}
    </div>
}

